import {Component, OnInit, ViewChild} from '@angular/core';
import {Response} from '@angular/http';
import {Router} from '@angular/router';

import {ModalConfirmationComponent} from 'shared/modals/modal-confirmation/modal-confirmation.component';
import {Thesis} from 'shared/classes/thesis';
import {SearchBarComponent} from 'shared/search-bar/search-bar.component';
import {ThesisOverviewService} from './services/thesis-overview.service';

@Component({
  selector: 'thesis-overview',
  templateUrl: './thesis-overview.component.html',
  styleUrls: ['./thesis-overview.component.css'],
})

export class ThesisOverviewComponent {

  public theses: Array<Thesis> = [];
  public filteredTheses: Array<Thesis> = [];
  public fieldsToSearch: Array<Array<string>> = [];
  public currentPage: Event;

  @ViewChild('deleteModal') public deleteModal: ModalConfirmationComponent;

  constructor(private thesisOverviewService: ThesisOverviewService,
              private router: Router) { }

  public ngOnInit(): void {
    this.thesisOverviewService.getTheses()
      .subscribe((theses: Array<Thesis>) => {
        this.theses = theses;
        this.filteredTheses = theses;
        this.prepareFieldsToSearch();
      });
  }

  public showDeleteModal(thesisId: string): void {
    const thesisTitle: string = this.getThesisById(thesisId).title;
    const content: string = `Sind Sie sicher, dass Sie die Thesise "${thesisTitle}" löschen möchten?`;

    this.deleteModal.setContent(content)
      .setEventData(thesisId)
      .show();
  }

  public editThesis(thesisId: string): void {
    this.router.navigate(['theses', 'details', {thesisId: thesisId}]);
  }

  public createThesis(): void {
    this.router.navigate(['theses', 'details']);
  }

  public deleteThesis(id: string): void {
    this.thesisOverviewService.deleteThesis(id)
      .subscribe((deleteResponse: Response) => {
        const index: number = this.theses.findIndex((thesis: Thesis) => {
          return thesis._id === id;
        });

        if (index > -1) {
          this.theses.splice(index, 1);
        }
      });
  }

  public filterTheses(eventThesis: Array<Thesis>): void {
    this.filteredTheses = eventThesis;
  }

  private prepareFieldsToSearch(): void {
    this.theses.forEach((thesis) => {
      this.fieldsToSearch.push([
        thesis.title.toLowerCase(),
      ]);
    });
  }

  private getThesisById(id: string): Thesis {
    return this.theses.find((thesis) => {
      return thesis._id === id;
    });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/thesis/thesis-overview/thesis-overview.component.ts